
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";

const HeroSection = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="text-center mb-12"
    >
      <h1 className="text-4xl md:text-6xl font-bold mb-6">
        Create your own
        <span className="bg-clip-text text-transparent bg-gradient-to-r from-primary to-accent">
          {" "}
          social token
        </span>
      </h1>
      <p className="text-muted-foreground text-lg max-w-2xl mx-auto mb-8">
        Empower your community with personalized tokens on Polygon Network.
        Connect, reward, and engage with your audience through meaningful interactions.
      </p>
      
      <div className="flex items-center justify-center gap-6 text-muted-foreground text-sm">
        <div className="flex items-center gap-2">
          <MessageCircle className="h-4 w-4" />
          <span>Community-driven discussions</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="inline-block w-4 h-4 rounded-full bg-primary/20 flex items-center justify-center text-xs">
            🤝
          </span>
          <span>Creator-fan relationships</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="inline-block w-4 h-4 rounded-full bg-primary/20 flex items-center justify-center text-xs">
            🌱
          </span>
          <span>Sustainable engagement</span>
        </div>
      </div>
    </motion.div>
  );
};

export default HeroSection;
